import React from 'react';

interface DeclarationSectionProps {
  formData: {
    acceptsAssociationPolicy: boolean;
    acceptsProfessionalConduct: boolean;
  };
  errors: Record<string, string>;
  onChange: (field: string, value: boolean) => void;
}

const DeclarationSection: React.FC<DeclarationSectionProps> = ({
  formData,
  errors,
  onChange
}) => {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm ring-1 ring-black/5 dark:ring-white/10 p-6 sm:p-8">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
        DICHIARA
      </h3>

      <div className="mb-6">
        <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
          di conoscere, accettandoli integralmente e senza alcuna riserva, i principi sanciti dallo Statuto, 
          dal suo Regolamento e del Codice Deontologico di settore e del Codice Etico dell'Associazione.
        </p>
        <p className="text-sm font-semibold text-gray-900 dark:text-white mb-3">
          In particolare:
        </p>
      </div>

      {/* Punto 1 */}
      <div className="mb-6 p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
        <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
          <span className="font-semibold">1.</span> impegnandosi a sostenere l'attuazione della politica dell'Associazione, 
          partecipando alle assemblee ed esprimendo la propria opinione;
        </p>
        
        <div className="flex items-center gap-6">
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="acceptsAssociationPolicy"
              checked={formData.acceptsAssociationPolicy === true}
              onChange={() => onChange('acceptsAssociationPolicy', true)}
              className="w-4 h-4 text-green-600 focus:ring-green-500"
              required
            />
            <span className="ml-2 text-sm font-medium text-green-700 dark:text-green-400">
              ✓ ACCETTA
            </span>
          </label>
          
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="acceptsAssociationPolicy"
              checked={formData.acceptsAssociationPolicy === false}
              onChange={() => onChange('acceptsAssociationPolicy', false)}
              className="w-4 h-4 text-red-600 focus:ring-red-500"
            />
            <span className="ml-2 text-sm font-medium text-red-700 dark:text-red-400">
              ✗ RIFIUTA
            </span>
          </label>
        </div>
        
        {errors.acceptsAssociationPolicy && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-400">{errors.acceptsAssociationPolicy}</p>
        )}
      </div>

      {/* Punto 2 */}
      <div className="mb-4 p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
        <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
          <span className="font-semibold">2.</span> conformando la propria condotta professionale ai principi di indipendenza, 
          imparzialità, riservatezza e rispetto dell'ambiente, senza condizionamenti di sorta;
        </p>
        
        <div className="flex items-center gap-6">
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="acceptsProfessionalConduct"
              checked={formData.acceptsProfessionalConduct === true}
              onChange={() => onChange('acceptsProfessionalConduct', true)}
              className="w-4 h-4 text-green-600 focus:ring-green-500"
              required
            />
            <span className="ml-2 text-sm font-medium text-green-700 dark:text-green-400">
              ✓ ACCETTA
            </span>
          </label>
          
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="acceptsProfessionalConduct"
              checked={formData.acceptsProfessionalConduct === false}
              onChange={() => onChange('acceptsProfessionalConduct', false)}
              className="w-4 h-4 text-red-600 focus:ring-red-500"
            />
            <span className="ml-2 text-sm font-medium text-red-700 dark:text-red-400">
              ✗ RIFIUTA
            </span>
          </label>
        </div>
        
        {errors.acceptsProfessionalConduct && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-400">{errors.acceptsProfessionalConduct}</p>
        )}
      </div>

      {/* Avviso se rifiuta */}
      {(formData.acceptsAssociationPolicy === false || formData.acceptsProfessionalConduct === false) && (
        <div className="mt-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
          <div className="flex items-start">
            <svg className="w-5 h-5 text-red-600 dark:text-red-400 mt-0.5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
            <p className="text-sm text-red-800 dark:text-red-300">
              <strong>Attenzione:</strong> L'accettazione di entrambi i punti è obbligatoria per procedere con l'iscrizione. 
              Se rifiuti uno o entrambi i punti, la domanda non potrà essere inviata.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeclarationSection;

